import Footer from 'components/Footer'
import Header from 'components/Header'
import { NoticeListCard } from 'components/NoticeListCard'
import * as React from 'react'
import { Status } from 'api/common/statuses'
import { NoticeSimplified } from 'api/common/types'
import { noticeAPI } from 'api/notice'

const SceneComponent: React.FC = () => {
  const [notices, setNotices] = React.useState<NoticeSimplified[]>([])
  React.useEffect(() => {
    noticeAPI((status, result) => {
      if (status === Status.Success) {
        setNotices(result.notices)
      }
    })
  }, [])
  return (
    <>
      <Header title="お知らせ一覧" />
      <main>
        <section className="mx-4 my-5">
          {notices.map((notice, index) => (
            <NoticeListCard notice={notice} key={index} />
          ))}
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
